var _defs, _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgEmoRischio(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Livello_1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 50.1 44.4",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .st0 {\n        fill: none;\n        stroke: #004291;\n        stroke-linecap: round;\n        stroke-linejoin: round;\n        stroke-width: 3px;\n      }\n\n      .st1 {\n        fill: #004291;\n      }\n    "))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M32.3,42.8h14.2c1.6,0,2.7-1.8,1.8-3.2L26.9,2.6c-.8-1.4-2.9-1.4-3.7,0L1.8,39.7c-.8,1.4.2,3.2,1.8,3.2h14.2"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M27.9,40.2c0,1.6-1.3,2.8-2.8,2.8s-2.8-1.3-2.8-2.8,1.3-2.8,2.8-2.8,2.8,1.3,2.8,2.8M25.1,34.1h0c-1.2,0-2.2-.9-2.3-2l-1.3-10c-.2-1.5.6-3,2-3.7,1-.5,2.2-.5,3.2,0,1.4.7,2.2,2.2,2,3.7l-1.3,10c-.1,1.2-1.1,2-2.3,2"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEmoRischio);
export default __webpack_public_path__ + "static/media/emo-rischio.a1c238af29d77f827055c72f4fb4c4c9.svg";
export { ForwardRef as ReactComponent };